if (!customElements.get('gp-gallery')) {
  customElements.define('gp-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const track = this.querySelector('.gp-track');
      const thumbs = [...this.querySelectorAll('[data-index]')];
      const count = this.querySelector('.gp-count');
      let index = 0;
      const go = n => {
        index = Math.max(0, Math.min(thumbs.length - 1, n));
        track.scrollTo({left:index * track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => go(index + Number(b.dataset.step))));
      thumbs.forEach(b => b.addEventListener('click', () => go(Number(b.dataset.index))));
      track.addEventListener('keydown', e => { if (['ArrowLeft','ArrowRight'].includes(e.key)) {e.preventDefault();go(index + (e.key === 'ArrowRight' ? 1 : -1));} });
      const update = () => {
        index = Math.round(track.scrollLeft / (track.clientWidth || 1));
        thumbs.forEach((b,i) => {if(i === index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
        count.textContent = `${index + 1} / ${thumbs.length}`;
        this.querySelector('[data-step="-1"]').disabled = index === 0;
        this.querySelector('[data-step="1"]').disabled = index === thumbs.length - 1;
      };
      track.addEventListener('scroll', update, {passive:true});
      update();
    }
  });
  document.addEventListener('change', e => {
    if(!e.target.matches('[data-gp-variant]')) return;
    const option = e.target.selectedOptions[0];
    const root = e.target.closest('.gp-mnl');
    root.querySelector('[data-gp-price]').textContent = option.dataset.price;
    const button = root.querySelector('.gp-submit');
    const enabled = button.dataset.enabled === 'true';
    button.disabled = !enabled || option.dataset.ready !== 'true';
    button.textContent = !enabled ? 'Commande momentanément suspendue' : option.dataset.ready === 'true' ? 'Ajouter ma gourmette au panier' : 'Variante indisponible';
  });
}
